import { c as _c } from "react/compiler-runtime";
import type * as React from "react";

// The Atlas brand mark: two thin, near-equal concentric rings with a large
// hollow center. Strokes use currentColor so it adapts to its surface — set the
// color via a text-* class on the caller (e.g. text-comp-text-tertiary for the
// muted-grey sidebar treatment).
export function AtlasMark(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <circle cx="12" cy="12" r="10.5" stroke="currentColor" strokeWidth="1.7" />;
    t2 = <circle cx="12" cy="12" r="7.9" stroke="currentColor" strokeWidth="1.7" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className || $[6] !== props) {
    t3 = <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className} {...props}>{t1}{t2}</svg>;
    $[5] = className;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}